import { render } from "./banner-carousel.vue?vue&type=template&id=a4b3920c"
import script from "./banner-carousel.vue?vue&type=script&lang=js"
export * from "./banner-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__